import React, { useEffect, useState } from 'react';
import Wrapper from '../Wrapper';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom/dist';
import { useNavigate } from 'react-router-dom';
import StudentFees from './StudentFees';
import StudentAttendance from './StudentAttendance';
const StudentFeeAttendance = () => {
  const navigate = useNavigate();
  const { id,id2,name} = useParams();
  const [courseDetails, setCourseDetails] = useState();
  const [loader, setLoader] = useState(false);
  const [tab, setTabs] = useState('student');
  useEffect(() => {
    fetchCourseDetails(id);
    fetchAdditionalImages(id);
  }, [id]);



 
  
  const fetchCourseDetails = (courseId) => {
    setLoader(true);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(`https://quran-backend-theta.vercel.app/v1/user/course/${courseId}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        console.log('DATA', data?.course);
        setCourseDetails(data?.course);
        setLoader(false);
      })
      .catch((error) => console.error(error));
  };



  const fetchAdditionalImages = async (id) => {
    try {
      const response = await fetch(
        `https://quran-backend-theta.vercel.app/v1/admin/course-additional-images/${id}`
      );
      const data = await response.json();

      if (data.success) {
        setAdditionalImages(data.additionalImages);
      } else {
        console.error('Failed to fetch additional images');
      }
    } catch (error) {
      console.error('Error fetching additional images:', error);
    }
  };

  



  return (
    <Wrapper>
      
      <h2 className="main_title ">{name}</h2>
      <p className=" text-[#1C1D1D]">Here are details of your courses</p>
      <div>
        <ul className=" mt-6 flex w-full gap-4 border-b">
          
          <li className="cursor-pointer" onClick={() => setTabs('student')}>
            <span
              className={` ${
                tab === 'student' ? 'text-[#FF7E00] border-b-2 border-[#FF7E00]' : 'text-gray-400'
              } `}
            >
              Fee Slips
            </span>
          </li>
          <li className="cursor-pointer" onClick={() => setTabs('documents')}>
            <span
              className={` ${
                tab === 'documents' ? 'text-[#FF7E00] border-b-2 border-[#FF7E00]' : 'text-gray-400'
              } `}
            >
              Attendance
            </span>
          </li>
         
        </ul>
      </div>

      { tab === 'student' ? (
        <StudentFees/>
      ) :(
        <StudentAttendance />
      )}
    </Wrapper>
  );
};

export default StudentFeeAttendance;
